import { useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { AuthModal } from "@/components/AuthModal";
import { Home } from "@/pages/Home";
import { Listings } from "@/pages/Listings";
import { PropertyDetail } from "@/pages/PropertyDetail";
import { MapView } from "@/pages/MapView";
import { Neighborhoods } from "@/pages/Neighborhoods";
import { Agents } from "@/pages/Agents";
import { PostProperty } from "@/pages/PostProperty";
import { Favorites } from "@/pages/Favorites";
import { Admin } from "@/pages/Admin";
import { MyListings } from "@/pages/MyListings";

const Footer = () => (
  <footer className="border-t border-[var(--line)] py-10 mt-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 grid md:grid-cols-3 gap-8">
      <div>
        <div className="font-serif text-lg font-semibold text-[var(--teak)]">NimmaSwathu</div>
        <p className="text-sm text-[var(--ink-muted)] mt-2 max-w-sm">Hyperlocal real estate for Mysuru. Buy, rent, list — street by street.</p>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider font-semibold text-[var(--ink-muted)]">Explore</div>
        <ul className="mt-3 space-y-2 text-sm">
          <li><Link to="/listings" className="hover:text-[var(--primary)]">All Listings</Link></li>
          <li><Link to="/map" className="hover:text-[var(--primary)]">Map View</Link></li>
          <li><Link to="/neighborhoods" className="hover:text-[var(--primary)]">Neighborhoods</Link></li>
          <li><Link to="/agents" className="hover:text-[var(--primary)]">Agents</Link></li>
        </ul>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider font-semibold text-[var(--ink-muted)]">The city</div>
        <p className="text-sm text-[var(--ink-muted)] mt-3 italic">&ldquo;Mysuru — the city of palaces, Yoga and chrysanthemum gardens.&rdquo;</p>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-8 text-xs text-[var(--ink-muted)]">© 2026 NimmaSwathu. Built with heritage in mind.</div>
  </footer>
);

function App() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const openAuth = (mode) => { setAuthMode(mode); setAuthOpen(true); };

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App flex flex-col min-h-screen">
          <Navbar onAuth={openAuth} />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home onAuth={openAuth} />} />
              <Route path="/listings" element={<Listings onAuth={openAuth} />} />
              <Route path="/buy" element={<Listings onAuth={openAuth} forcedType="buy" eyebrow="For Sale" title="Buy a Home in Mysuru" />} />
              <Route path="/rent" element={<Listings onAuth={openAuth} forcedType="rent" eyebrow="For Rent" title="Rent in Mysuru" />} />
              <Route path="/property/:id" element={<PropertyDetail onAuth={openAuth} />} />
              <Route path="/map" element={<MapView />} />
              <Route path="/neighborhoods" element={<Neighborhoods />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/post" element={<PostProperty onAuth={openAuth} />} />
              <Route path="/favorites" element={<Favorites onAuth={openAuth} />} />
              <Route path="/dashboard" element={<MyListings onAuth={openAuth} />} />
              <Route path="/admin" element={<Admin onAuth={openAuth} />} />
            </Routes>
          </main>
          <Footer />
          <AuthModal open={authOpen} mode={authMode} onOpenChange={setAuthOpen} />
          <Toaster position="top-right" richColors closeButton />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
